<template>
	<div class="series-suggestion">
		<div class="series-suggestion-top">
			<img :src="require(`@/assets/icon/${'close-gray.svg'}`)" @click="close">
			<h2>Voldemort</h2>
			<h4>Stories We Think You’ll Love</h4>
		</div>
		<swiper class="swiper series-suggestion-wrap" :options="swiperOption" :cleanup-styles-on-destroy="false"
      @ready="handleSwiperDirectiveReady"
      @click-slide="handleSwiperSlideClick"
      @slide-change-transition-start="handleSwiperSlideChangeTransitionStart">
			<swiper-slide
				v-for="(post, key) in posts" 
				:key="key" 
				class="series-suggestion-single d-flex" 
				:class="{ 'current' : active == key}" @click="active = key">
				<img :src="require(`@/assets/images/posts-img/${post.img}`)"/>
				<div class="series-suggestion-desc">
					<h2>{{ post.title }}</h2>
					<p>{{ post.desc }}</p>

					<div class="series-suggestion-btm" v-show="key==0 && nextPlay==true">
						<div class="suggestion-left">
							<p>Next part starts in <span>5 seconds</span></p>
						</div>
						<div class="suggestion-right">
							<button @click="nextplay()">Cancle</button>
						</div>
					</div>
					<div class="series-suggestion-btm" v-show="key!=0 || nextPlay==false">
						<div class="suggestion-left d-flex">
							<img :src="require(`@/assets/images/${post.author.profile}`)"/>
							<div>
								<h3>{{ post.author.name }}</h3>
								<p>I’m a writer ninjas</p>
							</div>
						</div>
						<div class="suggestion-right">
							{{ post.created_at }}
						</div>
					</div>

				</div>
			</swiper-slide><!-- end-series-suggestion-single -->
		</swiper>
		<!-- swipe-tut -->
		<swipe-tut v-show="!swipetut"></swipe-tut>
	</div>
</template>


<script>

	import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
	import 'swiper/css/swiper.css'

	import { EventBus } from '../../../main';
	export default {
      	name: "series-suggestion",
		components: {
		    Swiper,
		    SwiperSlide
		},
		data(){
			return {
				swiperOption: {
		          direction: 'vertical',
			      slidesPerView: 3,
			      slidesPerGroup: 3,
			      spaceBetween: 10,
			      slideClass: 'custom-slide-class',
		          mousewheel: true,
		        },
				swipetut:false,
				active:0,
				nextPlay:true,
				posts:[
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:true,
					},
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:false,
					},
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:false,
					},
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:false,
					},
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:false,
					},
					{
						img: 'sp2.svg',
						title: 'Ocean Story',
						desc: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document without relying on meaningful content',
						created_at: '4 days ago',
						author:{
							profile: 'avatar.png',
							name: 'Dara Adhelia',
						},
						active:false,
					}
				]
	      	}
	    },

	    methods: {
	        topTapHandler (direction) {
	            console.log(direction);
	        },
	        bottomTapHandler (direction) {
	            console.log("Bottom")  // May be left / right / top / bottom
	            console.log(direction)  // May be left / right / top / bottom
	        },

	    	close() {
	    		EventBus.$emit('close',false);
	    	},

	    	nextplay() {
	    		this.nextPlay=false;
	    		EventBus.$emit('nextplay',false);
	    	},

	    	isSwipetut() {
	    		this.swipetut = localStorage.getItem('swipetut');
	    	},
	    },

	    created() {
	    	EventBus.$on('swipetut', data => {
	            this.swipetut=data;
	            this.nextplay();
	        });
	        this.isSwipetut();
	    },

	    directives: {
		    swiper: directive
		}

    }

</script>
